import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toggleMenu, toggleMini } from "store/actions/menu";
import { logOut } from "store/actions/auth";
import { isBigger } from "store/actions/device";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Divider from "@mui/material/Divider";
import ListSubheader from "@mui/material/ListSubheader";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import AccountCircle from "@mui/icons-material/AccountCircle";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Badge from "@mui/material/Badge";
import { Link } from "react-router-dom";

// Importazione funzione API
import { getNotificationsCount } from "lib/notifications";

import MenuSearch from "components/template/menu-search";
import { SYSTEM_GROUP_ID, buildMenu } from "layout/menuConfig";
import { MenuButton, Logo, Title, WrapTopbar } from "./theme";
import { AppName, AppLogo } from "components/theme";

const isSearchShortcut = (event) =>
  (event.ctrlKey || event.metaKey) && !event.altKey && String(event.key).toLowerCase() === "k";

class Topbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accountMenuEl: null,
      notificationCount: 0,
      searchOpen: false,
    };
    this.pollingInterval = null;
  }

  componentDidMount() {
    this.fetchCount();
    this.pollingInterval = setInterval(() => this.fetchCount(), 60000);
    window.addEventListener("notificationRead", this.fetchCount);
    window.addEventListener("keydown", this.onKeyDown);
  }

  componentWillUnmount() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
    window.removeEventListener("notificationRead", this.fetchCount);
    window.removeEventListener("keydown", this.onKeyDown);
  }

  // Ctrl+K / Cmd+K opens the quick search from anywhere in the admin area.
  onKeyDown = (event) => {
    if (!isSearchShortcut(event) || this.props.routes === null) return;
    event.preventDefault();
    this.setState({ searchOpen: true });
  };

  fetchCount = async () => {
    try {
      const response = await getNotificationsCount();
      const count = response;
      this.setState({ notificationCount: count });
    } catch (error) {
      console.error("Errore nel recupero notifiche:", error);
    }
  };

  handleMenuAccount = (event) => {
    this.setState({ accountMenuEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ accountMenuEl: null });
  };

  // Desktop: extended / icons only. Small screens: open / close the floating drawer.
  onMenuButton = () => {
    if (isBigger(this.props.device, "md")) this.props.toggleMini();
    else this.props.toggleMenu();
  };

  renderSystemEntries = () => {
    const system = buildMenu(this.props.routes).find((group) => group.id === SYSTEM_GROUP_ID);
    if (!system) return null;
    return [
      <Divider key="system-divider" />,
      <ListSubheader key="system-header" disableSticky>{system.label}</ListSubheader>,
      ...system.children.map((entry) => (
        <MenuItem key={entry.path} component={Link} to={entry.path} onClick={this.handleClose}>
          {entry.label}
        </MenuItem>
      )),
    ];
  };

  renderAccountMenu = () => {
    const { accountMenuEl, notificationCount } = this.state;
    const open = accountMenuEl !== null;
    return (
      <div>
        <IconButton
          component={Link}
          to="/notifications/list"
          color="inherit"
          aria-label="Notifiche"
        >
          <Badge badgeContent={notificationCount} color="error">
            <NotificationsActiveIcon />
          </Badge>
        </IconButton>

        <IconButton
          onClick={this.handleMenuAccount}
          color="inherit"
          aria-label="Menu"
        >
          <AccountCircle />
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={accountMenuEl}
          open={open}
          onClose={this.handleClose}
        >
          <MenuItem component={Link} to={"/user/edit/" + this.props.userId} onClick={this.handleClose}>
            Il mio profilo
          </MenuItem>
          <MenuItem onClick={this.props.logOut}>Logout</MenuItem>
          {this.renderSystemEntries()}
        </Menu>
      </div>
    );
  };

  render() {
    const { routes } = this.props;
    const showMenuButton = routes !== null;
    return (
      <WrapTopbar>
        <AppBar position="fixed">
          <Toolbar>
            {showMenuButton && (
              <MenuButton>
                <IconButton color="inherit" onClick={this.onMenuButton} aria-label="Apri o chiudi il menu">
                  <MenuIcon />
                </IconButton>
              </MenuButton>
            )}
            <Logo src={AppLogo} />
            <Title>
              <Typography variant="h6" color="inherit">{AppName}</Typography>
            </Title>
            {showMenuButton && (
              <Tooltip title="Cerca una pagina (Ctrl+K)">
                <IconButton color="inherit" onClick={() => this.setState({ searchOpen: true })} aria-label="Cerca una pagina">
                  <SearchIcon />
                </IconButton>
              </Tooltip>
            )}
            {this.renderAccountMenu()}
          </Toolbar>
        </AppBar>
        {showMenuButton && (
          <MenuSearch
            open={this.state.searchOpen}
            groups={buildMenu(routes)}
            onClose={() => this.setState({ searchOpen: false })}
          />
        )}
      </WrapTopbar>
    );
  }
}

const mapStateToProps = (state) => ({
  routes: state.routing.routes,
  device: state.device.type,
  userId: state.auth.user.id,
});

const mapDispatchToProps = (dispatch) => ({
  toggleMenu: bindActionCreators(toggleMenu, dispatch),
  toggleMini: bindActionCreators(toggleMini, dispatch),
  logOut: bindActionCreators(logOut, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Topbar);
